import { isPast } from "date-fns";
import { Banner } from "@chef/components";
import { ORDER_STATUS_IDS, ORDER_TYPE_IDS } from "@chef/constants";
import { formatDate, isAccountPaused } from "@chef/helpers";
import { useBillingQuery, useOrdersQuery } from "@chef/state-management";
import { intl } from "./DeliveryCutoffBanner.Intl";

export const DeliveryCutoffBanner = () => {
  const { data: { orders: generatedOrders = [] } = {} } = useOrdersQuery({
    orderTypes: [ORDER_TYPE_IDS.RECURRING],
    orderStatuses: [ORDER_STATUS_IDS.PROCESSING],
    count: 1,
  });

  const { data: billingQuery } = useBillingQuery();

  const isPaused = isAccountPaused(billingQuery?.billing?.status || 10);

  const nextDeliveryOrder = generatedOrders[0];

  if (!nextDeliveryOrder || isPast(new Date(nextDeliveryOrder?.deliveryDate))) {
    return null;
  }

  return (
    <Banner highlighted>
      {isPaused ? intl.THE_LAST_DELIVERY_IS_ON : intl.DELIVERY_ON_THE_WAY}
      {formatDate(nextDeliveryOrder.deliveryDate, "dd LLL")}
    </Banner>
  );
};
